/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencySubstantiveEvaluation = {

	delete (context, substantiveEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-substantive-evaluation"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, substantiveEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-substantive-evaluation"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-substantive-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-substantive-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postTeamUsers (context, agencyProjectId, teamUserIds, onSuccess, onError, options) {
		Api.post(context,
			"/agency-substantive-evaluation/team-users"
			+ "?agencyProjectId=" + agencyProjectId
			, teamUserIds
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, substantiveEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-substantive-evaluation"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-substantive-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, substantiveEvaluationId, agencySubstantiveEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-substantive-evaluation/data"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, agencySubstantiveEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, substantiveEvaluationId, agencySubstantiveEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-substantive-evaluation/finish"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, agencySubstantiveEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
